import { DatePickerInput as MantineDatePickerInput } from '@mantine/dates';
import { ChevronDown } from 'lucide-react';

export const DatePickerInput = MantineDatePickerInput.extend({
	defaultProps: {
		popoverProps: {
			offset: 0,
			classNames: {
				dropdown: 'mantine-DatePickerInput-dropdown',
			},
		},
		rightSection: <ChevronDown />,
		rightSectionPointerEvents: 'none',
	},
	classNames: {
		levelsGroup: 'mantine-DatePicker-levelsGroup',
		weekday: 'mantine-DatePicker-weekday',
		day: 'mantine-DatePicker-day',
		calendarHeaderLevel: 'mantine-DatePicker-calendarHeaderLevel',
		calendarHeaderControl: 'mantine-DatePicker-calendarHeaderControl',
		calendarHeaderControlIcon: 'mantine-DatePicker-calendarHeaderControlIcon',
		monthsListControl: 'mantine-DatePicker-monthsListControl',
		yearsListControl: 'mantine-DatePicker-yearsListControl',
	},
});
